// extracted by mini-css-extract-plugin
export var table = "index-module--table--aMrb9";
export var tableRow = "index-module--tableRow--rtIdP";
export var tableRow_header = "index-module--tableRow_header--7bzb8";
export var tableRow_footer = "index-module--tableRow_footer---xdQX";